import UploadIcon from "../icons/UploadIcon";
import GitHubIcon from "../icons/GitHubIcon";
import styles from "./SourceBadge.module.css";

/**
 * Where a My Skills record came from:
 *   - web-upload: contributed through the marketplace web form (verified).
 *   - github:     discovered from a GitHub repo (self-asserted authorship).
 * Derived from the record's `ownership`, not stored on the record itself.
 */
export type SkillSource = "web-upload" | "github";

interface SourceBadgeProps {
  source: SkillSource;
}

/**
 * Small presentational pill for a record's origin. Mirrors StatusBadge: static
 * layout in the CSS module, an SVG glyph paired with a visible text label (the
 * glyph is decorative, so aria-hidden). Only the My Skills page needs it —
 * Contract 3 (`marketplace.json`) carries no ownership signal.
 */
export default function SourceBadge({ source }: SourceBadgeProps) {
  const isWebUpload = source === "web-upload";
  return (
    <span className={styles.badge}>
      {isWebUpload ? (
        <UploadIcon className={styles.icon} />
      ) : (
        <GitHubIcon className={styles.icon} />
      )}
      {isWebUpload ? "Web upload" : "GitHub"}
    </span>
  );
}
